<app-hero-home></app-hero-home>
<app-about-me></app-about-me>
<app-proyecto-destacados></app-proyecto-destacados>
<app-blogs-destacados></app-blogs-destacados>
